module.exports = __webpack_public_path__ + "static/media/edenredSVG.3666e843.svg";